import React, { useRef } from "react";
import { useLanguage } from "../i18n/LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";
import imgAna from "../assets/ailemasset.png";
import imgAlisveris from "../assets/alisverisasset.png";
import imgTakvim from "../assets/takvimasset.png";
import imgFinans from "../assets/finansasset.png";
import imgGorev from "../assets/gorevlerasset.png";
import imgHarcama from "../assets/harcamalarasset.png";
import imgSaglik from "../assets/saglikasset.png";
import imgHarita from "../assets/aileharitasiasset.png";
import imgCocuk from "../assets/cocuktakibiasset.png";
import imgChat from "../assets/ailesohbetiasset.png";
import imgBelgeler from "../assets/belgelerasset.png";
import imgNePisirsam from "../assets/nepisirsemasset.png";
import imgAssistant from "../assets/aileasistaniasset.png";
import imgYonetim from "../assets/yonetimasset.png";
import { isAndroidRestrictedPage } from "../utils/platformFeatures";
import { preloadMapKitJs } from "../services/mapKitService";

function SideMenu({ acik, kapat, aktifSayfa, setAktifSayfa, permissions, onChangeLang, yoneticiMi, tema, setTema }) {
  const { t, lang } = useLanguage();
  const isLightTheme = tema === "light";

  const toggleTheme = () => {
    if (typeof setTema === "function") {
      const yeniTema = isLightTheme ? "dark" : "light";
      setTema(yeniTema);
      document.body.setAttribute("data-tema", yeniTema);
      document.documentElement.setAttribute("data-tema", yeniTema);
      localStorage.setItem("tema", yeniTema);
    }
  };

  const touchStartX = useRef(0);
  const touchStartY = useRef(0);

  const handleTouchStart = (e) => {
    const t = e.touches?.[0];
    if (!t) return;

    touchStartX.current = t.clientX;
    touchStartY.current = t.clientY;
  };

  const handleTouchEnd = (e) => {
    const t = e.changedTouches?.[0];
    if (!t) return;

    const dx = t.clientX - touchStartX.current;
    const dy = Math.abs(t.clientY - touchStartY.current);

    if (dx > 70 && dy < 80) {
      kapat();
    }
  };

  const MENU_ITEMS = [
    { id: "ana",               label: t("nav.home"),           img: imgAna,        pageKey: "home" },
    { id: "alisveris",         label: t("nav.shopping"),       img: imgAlisveris,  pageKey: "shopping" },
    { id: "takvim",            label: t("nav.calendar"),       img: imgTakvim,     pageKey: "calendar" },
    { id: "finans",            label: t("nav.finance"),        img: imgFinans,     pageKey: "finance" },
    { id: "gorev",             label: t("nav.tasks"),          img: imgGorev,      pageKey: "tasks" },
    { id: "harcama",           label: t("nav.sharedExpenses"), img: imgHarcama,    pageKey: "sharedExpenses" },
    { id: "saglik",            label: t("nav.health"),         img: imgSaglik,     pageKey: "health" },
    { id: "harita",            label: t("nav.map"),            img: imgHarita,     pageKey: "harita" },
    { id: "cocuk",             label: t("nav.children"),       img: imgCocuk,      pageKey: "children" },
    { id: "chat",              label: t("nav.chat"),           img: imgChat,       pageKey: "chat" },
    { id: "belgeler",          label: t("nav.documents"),      img: imgBelgeler,   pageKey: "documents" },
    { id: "nePisirsam",        label: t("nav.cooking"),        img: imgNePisirsam, pageKey: "nePisirsam" },
    { id: "activity",          label: t("nav.activity"),       img: null,          pageKey: "activity" },
    { id: "assistant",         label: t("nav.assistant"),      img: imgAssistant,  pageKey: "assistant" },
    { id: "kullaniciYonetimi", label: t("nav.management"),     img: imgYonetim,    pageKey: "userManagement" },
  ];

  const izinVar = (key) => {
    if (yoneticiMi) return true;
    return permissions?.pages?.[key] !== false;
  };

  return (
    <div className={acik ? "sideMenuWrap open" : "sideMenuWrap"} onClick={kapat}>
      <div
        className="sideMenu"
        onClick={(e) => e.stopPropagation()}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        {/* Başlık */}
        <div className="sideMenuHeader">
          <div className="sideMenuBrand">
            <div className="sideMenuLogo">
              <img src="/logo192.png" alt={t("app.name")} className="sideMenuLogoImg" />
            </div>
            <div className="sideMenuBrandText">
              <div className="sideMenuTitle">{t("menu.brand")}</div>
              <div className="sideMenuSub">{t("menu.brandSub")}</div>
            </div>
          </div>
          <button className="sideClose" onClick={kapat}>×</button>
        </div>

        <div className="sideMenuDivider" />

        <nav className="sideMenuNav">
          {MENU_ITEMS.filter((m) => izinVar(m.pageKey) && !isAndroidRestrictedPage(m.id)).map((m) => (
            <button
              key={m.id}
              className={aktifSayfa === m.id ? "sideItem active" : "sideItem"}
              onPointerDown={m.id === "harita" ? () => { void preloadMapKitJs(lang).catch(() => {}); } : undefined}
              onClick={() => { setAktifSayfa(m.id); kapat(); }}
            >
              <span className="sideItemIcon">
                {m.img
                  ? <img src={m.img} alt="" className="sideItemIconImg" />
                  : <span>✨</span>}
              </span>
              <span className="sideItemLabel">{m.label}</span>
              {aktifSayfa === m.id && <span className="sideItemDot" />}
            </button>
          ))}
        </nav>

        <div
  className="sideMenuFooter"
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "4px",
    paddingRight: "14px",
  }}
>
          {/* Dil Seçici */}
          <LanguageSwitcher variant="sidemenu" onChangeLang={onChangeLang} />

          <button
            type="button"
            className={isLightTheme ? "sideMenuLangBtn sideThemeToggleBtn light" : "sideMenuLangBtn sideThemeToggleBtn dark"}
            onClick={toggleTheme}
            aria-label={t("settings.theme")}
            title={isLightTheme ? t("settings.theme.dark") : t("settings.theme.light")}
             
          >
            {isLightTheme ? "☀️" : "🌙"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SideMenu;
